(function () {
  function initHelp(scope) {
    var sections = (scope || document).querySelectorAll("[data-fdh-section]:not([data-fdh-ready])");

    sections.forEach(function (section) {
      section.setAttribute("data-fdh-ready", "true");

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry, index) {
            if (!entry.isIntersecting) {
              return;
            }

            setTimeout(function () {
              entry.target.classList.add("on");
            }, index * 65);

            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px"
        }
      );

      section.querySelectorAll(".r").forEach(function (element) {
        observer.observe(element);
      });
    });
  }

  initHelp(document);

  document.addEventListener("shopify:section:load", function (event) {
    initHelp(event.target);
  });
})();
